<template>
  <div class="container-fluid card">
    <section>
      <div class="">
        <div class="row justify-content-center">
          <div class="">
            <div class="card-body text-center">
              <input class="inputNumberClient form-control" ref="inputNumberClient" type="text" v-model="model" placeholder="Modelo ó Codigo" min="0" v-on:keyup.enter="loadItems"  autofocus/>
              <!-- <button class="ml-2 btn btn-danger" @click="loadItems()" :readonly="esperar">Buscar</button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center mt-5 mb-4">
              <input type="date" v-model="dateInit" name="fechaInicial" class="mt-1 ml-2 form-control col-2">
              <input type="date" v-model="dateEnd" :min="dateInit" name="fechaFinal" class="mt-1 ml-2 form-control col-2">
              <!-- <button class="btn btn-secondary ml-3" @click="getTickets($route.params.client !== undefined ? $route.params.client.key_client : null)">Buscar</button> -->
              <button class="ml-2 btn btn-danger" @click="loadItems()" >Buscar</button>
        </div>
    </section>
    <!-- por pagina {{ perPage }} -->
    <section class="card mt-5">
      <div class="row justify-content-end mb-4 mt-4">
        <jsonExcel :data="items"
          class="btn btn-secondary"
          :fields= "{
            'Orden': 'id_order',
            'Cliente': 'client',
            'Catalogo': 'catalogo',
            'Página': 'pagina',
            'Estatus': 'marca',
            'Modelo': 'modelo',
            'Color': 'color',
            'Talla': 'numero',
            'Estatus': 'status',
            'Proveedor': 'provider',
            'Codigo de Barras': 'barcode',
            'Fecha de Registro': 'registration_date',
            'Fecha de Compra': 'date_buy'
          }"
          worksheet="Reporte de productos"
          name="Reporte de productos.xls"
        >
          Descargar a Excel
        </jsonExcel>
        </div>
        <b-table
            selectable
            class="table-adelantazo"
            :select-mode="selectMode"
            responsive="sm"
            ref="selectableTable"
            @row-selected="onRowSelected"
            selectedVariant="success"
            show-empty
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            stacked="md"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
         >
                <template
                  v-slot:cell(date)="row"
                >{{ getDateFormatEpoch(row.item.date) }}</template>
                <template v-slot:cell(total)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item)" />
                  </div>
                </template>
                <template v-slot:cell(action)="row">
                  <div align="center" class="history-amount">
                    <b-dropdown id="dropdown-1" text="Acciones" class="m-md-2">
                    <b-dropdown-item @click="volverPedir(row.item)">
                      <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Pedir de Nuevo
                    </b-dropdown-item>
                    <b-dropdown-item @click="showDetail(row.item)">
                      <font-awesome-icon :icon="['fa', 'arrows-alt']"/> Ver movimientos
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="cancelarPedido(props)" style="background: red; color: white">
                      <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Cancelar
                    </b-dropdown-item> -->
                  </b-dropdown>
                  </div>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <!-- <div slot="RequestDate" slot-scope="row">{{ row }}</div> -->
              </b-table>
    </section>
    <modal name="DetalleInventario" :adaptive="true" :scrollable="true" width="800" height="750" class="">
    <div class="text-right">
        <span class="close-modal" @click="$modal.hide('DetalleInventario')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass">
        <h2>Detalle de inventario</h2>
        <h5>{{detailStocktaking.producto}}</h5>
        <h5>Stock actual:
          <strong style="color: blue;">
            {{detailStocktaking.stock_actual}}
          </strong>
        Unidades
        <!-- <span class="ayuda-css" title="Stock actual en almacén">?</span>
        <span class="stock-num">15</span>
        <div class="stock-tooltip">
          <div><strong>Compras:</strong> <span class="entradas">48</span></div>
          <div><strong>Ventas:</strong> <span class="salidas">33</span></div>
          <div><strong>Stock actual:</strong> <span class="actual">15</span></div>
        </div> -->
      </h5>
        <!-- {{ detailStocktaking }} -->
        <!-- {{itemsInventarioDetail}} -->
        <div class="mt-3 col-lg-12" style="overflow: scroll;height: 550px !important;">
          <b-table
            show-empty
            :fixed="true"
            :borderless="true"
            :items="itemsInventarioDetail"
            :fields="fieldsDetail"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            class="table tableDetail"
          >
            <template v-slot:cell(name)="row">
              {{ row.item.name}}
              <p @click="printTicket(row.item)" style="color: blue; cursor: hand;" v-if="row.item.name !== 'COMPRA'">
                {{ row.item.folio === null ? '' : 'Folio: ' + row.item.folio }}
              </p>
              <p v-else @click="printTicket(row.item)" style="color: blue; cursor: hand;">
                {{ row.item.folio === null ? '' : 'Folio: ' + row.item.folio.id_buy }}
              </p>
            </template>
          </b-table>
        </div>
      </div>
    </modal>
    <ticket :ticket="ticketDeCompra" :enterprise="enterpriseData.name" :print="countPrint"/>
    <reportBuy :ticket="ticketDeCompra" :enterprise="enterpriseData.name" :print="countPrintReportBuy"/>
    <devolutionTicket :folio="ticketDeCompra" :enterprise="enterpriseData.name" :print="countPrintDevolution" :type="'Devolucion'"/>
    </div>
</template>
<script>
import { BTable, BDropdown, BDropdownItem } from 'bootstrap-vue'
import getTimeFormat from '@/mixins/getTimeFormat'
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
// import VueHtml2pdf from 'vue-html2pdf'
// import VueBarcode from 'vue-barcode'
import moment from 'moment'
import ticket from '../sales/ticket'
import reportBuy from './PDFCompra'
import devolutionTicket from '../sales/devolutionTicket'
import JsonExcel from 'vue-json-excel'

export default {
  mixins: [getTimeFormat],
  components: {
    BTable,
    BDropdown,
    BDropdownItem,
    ticket,
    devolutionTicket,
    reportBuy,
    JsonExcel
    // VueHtml2pdf,
    // VueBarcode
  },
  data () {
    return {
      dateInit: null,
      dateEnd: null,
      model: null,
      provider: [],
      tickets: [],
      barcode_option: {
        lineColor: '#0aa'
      },
      htmlToPdfOptions: {
        margin: [12, 0, 12, 0],
        filename: 'algo',
        html2canvas: {
          scale: 3,
          useCORS: true
        }
      },
      selectMode: 'multi',
      selected: [],
      dateI: null,
      dateF: null,
      items: [],
      fields: [
        { key: 'id_order', label: 'Id Orden', sortable: true, sortDirection: 'desc' },
        { key: 'client', label: 'Cliente', sortable: true, sortDirection: 'desc' },
        { key: 'catalogo', label: 'Catalogo', sortable: true, sortDirection: 'desc' },
        { key: 'pagina', label: 'Página', sortable: true, sortDirection: 'desc' },
        { key: 'marca', label: 'Estatus', sortable: true, sortDirection: 'desc' },
        { key: 'modelo', label: 'Modelo', sortable: true, sortDirection: 'desc' },
        { key: 'color', label: 'Color' },
        { key: 'numero', label: 'Talla' },
        { key: 'status', label: 'Estatus' },
        { key: 'provider', label: 'Proveedor' },
        { key: 'barcode', label: 'Codigo de Barras' },
        { key: 'comentario', label: 'Comentario' },
        { key: 'registration_date', label: 'Fecha de Registro' },
        { key: 'date_buy', label: 'Fecha de Compra' },
        { key: 'action', label: 'Acciones' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 200,
      pageOptions: [200, 400],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      detailStocktaking: [],
      itemsInventarioDetail: [],
      fieldsDetail: [
        // { key: 'id_client', label: 'No. cliente', sortable: true, sortDirection: 'desc' },
        { key: 'client', label: 'Cliente', sortable: true, sortDirection: 'desc' },
        { key: 'name', label: 'Movimiento', sortable: true, sortDirection: 'desc' },
        { key: 'type', label: 'Tipo', sortable: true, sortDirection: 'desc' },
        { key: 'cantidad', label: 'Cantidad', sortable: true, sortDirection: 'desc' },
        { key: 'date', label: 'Fecha', sortable: true, sortDirection: 'desc' }
      ],
      ticketDeCompra: 0,
      folioCompra: 0,
      enterpriseData: [],
      countPrint: 0,
      devolutionFolio: 0,
      countPrintDevolution: 0,
      countPrintReportBuy: 0
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    onRowSelected (items) {
      this.selected = items
    },
    async showDetail (args) {
      // console.log(args)
      this.detailStocktaking = args
      await this.detalleInventario(args)
      this.$modal.show('DetalleInventario')
    },
    async detalleInventario (args) {
      try {
        this.itemsInventarioDetail = []
        const params = {
          order_id: args.id_order,
          enterpise: this.user.enterprise_id,
          type: args.catalogo === 'S/C ALMACEN' ? 'almacen' : 'cliente'
        }
        const response = await axiosAdelaService.post('/detailInventoryByOrderId', params)
        // console.log('response.data.rows', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            response.data.rows.forEach(el => {
              this.itemsInventarioDetail.push({
                client: el.fullname,
                name: el.name,
                cantidad: el.entrada > el.salida ? el.entrada : el.salida,
                date: moment(el.date).format('YYYY-MM-DD'),
                id_client: el.id_client,
                type: el.entrada === 1 ? 'ENTRADA' : 'SALIDA',
                folio: el.folio
              })
              // this.perPage = response.data.totalRecords
            })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo obtener el inventario, por favor intentelo más tarde.')
      }
    },
    getFormattedAmount (row) {
      if (row) {
        return '$ ' + this.$formatNumberCurrency(row.total, 'MXN') + ' <span class="mxn">MXN</span>'
      } else {
        return ''
      }
    },
    async loadItems () {
      try {
        const params = {
          dateInit: this.dateInit,
          dateEnd: this.dateEnd,
          enterprise_id: this.user.enterprise_id,
          model: this.model === '' ? null : this.model
        }
        // console.log('parametros', params)
        const response = await axiosAdelaService.post('/getProductsReport', params)
        // console.log('getDevolutionProvider', response)
        if (response.status === 200) {
          const x = response.data.rows
          x.forEach(el => {
            el.registration_date = moment(el.registration_date).format('YYYY-MM-DD')
            el.date_buy = moment(el.date_buy).format('YYYY-MM-DD')
            // el.status = el.cantidad > 0 ? 'Activo' : 'CANCELADO'
            el.client = el.id_client + ' - ' + el.client
            if (el.status_id === 3) {
              el._rowVariant = 'danger'
            }
          })
          this.items = x
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    async volverPedir (data) {
      // console.log(data)
      const request = {
        catalogo: data.catalogo,
        marca: data.marca,
        modelo: data.modelo,
        numero: data.numero,
        cantidad: data.cantidad,
        delivery_date: data.delivery_date,
        id_order: data.id_order,
        user_id: this.user.user_admin_id
      }
      // console.log(request)
      const response = await axiosAdelaService.post('/reapplyOrderNew', request)
      // console.log('reapplyOrder', response)
      if (response.status === 200) {
        this.jsondata = []
        this.jsondataFaltantes = []
        this.$toastedPush({
          message: 'Se volvio a solicitar el producto con exito..',
          type: 'success'
        })
        // await this.getOrdersForCllientForSales()
        await this.loadItems()
      }
    },
    async printEtiquetas () {
      try {
        this.tickets = []
        const params = {
          tickets: this.selected,
          enterprise: this.user.enterprise_id
        }
        // console.log('parametros', params)
        const response = await axiosAdelaService.post('/searchTiketForBuys', params)
        // console.log('GetBarcodesforTicket', response)
        if (response.status === 200) {
          const data = response.data
          for (const key in data) {
            for (const key2 in data[key]) {
              // console.log('fecha de compra', moment(data[key][key2].date_buy).format('YYYY-MM-DD'))
              data[key].date_buy = moment(data[key][key2].date_buy).format('YYYY-MM-DD')
              this.tickets.push(data[key][key2])
            }
          }
          this.$refs.html2Pdf.generatePdf()
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    async getCurrentEnterprise () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getEnterprisesSelected', request)
        // console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.enterpriseData = orders.data.rows[0]
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async printCompra () {
      try {

      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    printTicket (row) {
      // console.log('ESTO ES ROW', row)
      this.ticketDeCompra = row.folio
      if (row.name === 'VENTA') {
        this.countPrint++
      }
      if (row.name === 'DEVOLUCION CLIENTE') {
        this.countPrintDevolution++
      }
      if (row.name === 'COMPRA') {
        this.countPrintReportBuy++
        this.ticketDeCompra = row.folio.id_buy
      }
    }
  },
  async mounted () {
    await this.getCurrentEnterprise()
    // console.log('this.$route.params', this.$route.params)
    await this.loadItems(this.$route.params)
  }
}
</script>
<style>
.etiqueta {
    width: 66mm !important;
    height: 25mm !important;
    /* background: black;s */
    padding: 0px !important;
}
.etiqueta svg {

}
.labels {
    width: 60mm;
    font-size: 9px;
}
.labels p {
    line-height: 1;
    margin: 0;
}
.labelsComplete {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
/* grid-auto-rows: minmax(66mm, auto); */
}
.tableDetail tbody tr {
  font-size: 12px !important;
}
.stock-cell {
  position: relative;
  display: inline-block;
}

.stock-num {
  cursor: help;
  font-weight: bold;
  padding: 4px 8px;
  background: #e3f2fd;
  border-radius: 6px;
  color: #1976d2;
  font-size: 14px;
}

.stock-num::after {
  content: " i";
  margin-left: 6px;
  font-size: 12px;
  color: #1976d2;
  font-weight: bold;
  font-style: italic;
}

/* El tooltip oculto que aparece al hacer hover */
.stock-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  white-space: nowrap;
  z-index: 1000;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  margin-bottom: 8px;
}

.stock-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border: 6px solid transparent;
  border-top-color: #333;
}

/* Mostrar al hacer hover */
.stock-cell:hover .stock-tooltip {
  visibility: visible;
  opacity: 1;
}
</style>
